/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadDocumentStats } from './LeadDocumentStats';
import {
    LeadDocumentStatsFromJSON,
    LeadDocumentStatsFromJSONTyped,
    LeadDocumentStatsToJSON,
} from './LeadDocumentStats';

/**
 * 
 * @export
 * @interface FindLeadsBatchWithDocumentStats200Response
 */
export interface FindLeadsBatchWithDocumentStats200Response {
    /**
     * 
     * @type {Array<LeadDocumentStats>}
     * @memberof FindLeadsBatchWithDocumentStats200Response
     */
    data?: Array<LeadDocumentStats>;
}

/**
 * Check if a given object implements the FindLeadsBatchWithDocumentStats200Response interface.
 */
export function instanceOfFindLeadsBatchWithDocumentStats200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindLeadsBatchWithDocumentStats200ResponseFromJSON(json: any): FindLeadsBatchWithDocumentStats200Response {
    return FindLeadsBatchWithDocumentStats200ResponseFromJSONTyped(json, false);
}

export function FindLeadsBatchWithDocumentStats200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindLeadsBatchWithDocumentStats200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(LeadDocumentStatsFromJSON)),
    };
}

export function FindLeadsBatchWithDocumentStats200ResponseToJSON(value?: FindLeadsBatchWithDocumentStats200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(LeadDocumentStatsToJSON)),
    };
}

